export default __webpack_public_path__ + "static/media/O-122.421f5566.png";